var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barcode"},[_c('img',{attrs:{"id":"barcode"}})])
}]

export { render, staticRenderFns }